import React          from 'react';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';

const t1 = 'כתבו את התרגיל'
const t2 = 'פתרו את התרגיל'

const useStyles = makeStyles(() => ({
    root: {
        position:        'fixed',
        left:            '50%',
        transform:       'translate(-50%, 0%)',
        height:          40,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-around',
        textAlign:       'center',
    },
    text: {
      position:        'fixed',
      left:            '50%',
      transform:       'translate(-50%, 0%)',
      height:          40,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-around',
      textAlign:       'center',
      color:           colors.blue,
      fontSize:        40
    },
    button: {
        height:          40,
        width:           140,
        fontSize:        20,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        borderRadius:    '0.5em',
        backgroundColor: colors.blue,
        color:           '#FFF'
    },
    buffer: {
      height:  40,
      width:   140,
      opacity: 0
    }
    
}))

type ButtonContainerProps = {
    size:                  number[];
    target_size:           number;
    selectedEggs:          number;
    target0Value:          number;
    target1Value:          number;
    wideScreen:            boolean;
    success:               boolean;
    stage1complete:        boolean;
    dragOrSelect:          string;
    transferEggs:          () => void;
    handleDragButtonClick: () => void;
    setDragOrSelect:       (val: string) => void;
}

type ButtonProps = {
  variant:     string;
  style:       {};
  handleClick: () => void;
}

const Button: React.FC<ButtonProps> = ({ style, variant, handleClick }) => {

  const classes = useStyles();

  return(
    <div 
      className = { classes.button }
      style     = { style } 
      onClick   = { handleClick }
    >
      { variant }
    </div>
  )
}


const ButtonContainer: React.FC<ButtonContainerProps> = ({ 
    size,
    target_size,
    selectedEggs,
    target0Value,
    target1Value,
    dragOrSelect,
    wideScreen,
    stage1complete,
    success, 
    transferEggs,
    handleDragButtonClick,
    setDragOrSelect,
 }) => {

 const classes = useStyles();

  const handleSelect = () => {
    setDragOrSelect('select')
  }

  const handleTransfer = () => {
      if (!selectedEggs) {
          return
      }
      else {
        transferEggs()
      }
  }

  const [text, root, drag, select, transfer] = React.useMemo(() => {

      const buttonWidth = wideScreen ? 140 : 90;
      const trans = `translate(0px, ${ stage1complete && !success ? 0 : -100 }vh)`

      return[
          {
            width:  wideScreen ? 600 : '97vw',
            //top:    size[1]/2 - target_size/2 - 65,
            top: (size[1]/2) - (target_size/2) - 70//(size[0] > 1000 ? 70 : 100),
          },
          {
            width:  wideScreen ? 600 : '60vw',
            //top:    size[1] > 600 ? '10vh' : 20,
            top: (size[1]/2) - (target_size/2) - 130//(size[0] > 1000 ? 130 : 160),
          },
          {
            width:     buttonWidth,
            transform: trans,
            opacity:   (target0Value && target1Value) && (dragOrSelect !== 'select') ? 1 : 0,
            cursor:    (target0Value && target1Value) && (dragOrSelect !== 'select') ? 'pointer' : 'default',
          },
          {
            width:     buttonWidth,
            transform: trans,
            opacity:   (target0Value && target1Value) && (dragOrSelect !== 'drag') ? 1 : 0,
            cursor:    (target0Value && target1Value) && (dragOrSelect !== 'drag') ? 'pointer' : 'default',

          },
          {
            width:     buttonWidth,
            transform: trans,
            opacity:   selectedEggs ? 1 : 0,
            cursor:    selectedEggs ? 'pointer' : 'default'
          }
      ]
  },[size, wideScreen, target_size, selectedEggs, target0Value, target1Value, dragOrSelect, stage1complete, success])
 

  return (
    <>
        <div 
          className = { classes.text }
          style     = { text } 
        >
          { stage1complete ? (success ? '' : t2) : t1 }
        </div>
        <div 
          className = { classes.root }
          style     = { root } 
        >
            <Button variant = { `סמנו ביצים` }  style = { select } handleClick = { handleSelect }/>
            <div className = { classes.buffer }/>
            {
              dragOrSelect !== 'select'
              &&
              <Button variant = { `גררו ביצים` } style = { drag }   handleClick = { handleDragButtonClick }/>
            }
            {
              dragOrSelect === 'select'
              &&
              <Button variant = { `העבירו ביצים` } style = { transfer } handleClick = { handleTransfer }/>
            }
        </div>
    </>
  );
}



export default ButtonContainer;








